import { Loader, Typography } from '@modulor/react';
import { useSkeletonTranslation } from 'hooks/useSkeletonTranslation';

const DisplayFormLoader = () => {
  const { skeletonT } = useSkeletonTranslation();
  return (
    <div className="deposit-delayed-loader">
      <Loader size="large" variant="circle" />
      <div className="deposit-delayed-loader__text">
        <Typography color="text-title" variant="title-2-semibold">
          {skeletonT('PH.DF.LOADER.TEXT')}
        </Typography>
        <Typography color="text-body" variant="body-regular">
          {skeletonT('PH.DF.LOADER.SUB_TEXT')}
        </Typography>
      </div>
    </div>
  );
};

export default DisplayFormLoader;
